const controller = 'file';

export const downloadFile = async (file) => {
    try {
        const response = await fetch(`/api/${controller}/download`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(file)
        });
        return response;
    } catch (error) {
        throw error.response?.data || error.message;
    }
}